import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { ButtonColored } from '../../program/components/ButtonColored';
import React from 'react';

import { openUrlInNewTab } from '../../util/window-utils';

export const LearnMoreButton = (props: { url: string; analyticsEvent?: AnalyticsEvent }) => {
  const { url, analyticsEvent } = props;
  return (
    <ButtonColored
      onClick={() => {
        openUrlInNewTab(url, {
          analyticsEvent,
        });
      }}
      text="Learn more"
    />
  );
};
